export const SET_TIME_ZONE = 'timezone/SET_TIME_ZONE'
export const SET_TIME_ZONE_IS_INITED = 'timezone/SET_TIME_ZONE_IS_INITED'
